<section class="container mt-5">

    <div class="row">
        <div class="col-sm-12 xs-text-center">
            <h2>Todas las etapas del evento {{evento?.nombre}}</h2>
        </div>
        <div class="col-sm-12" style="text-align: center;">
            <button class="btn btn-success" routerLink="/administradores/admin/eventos/lista">Atras</button>
        </div>
        <div class="col-sm-12">
            <div *ngIf ='message' class="alert alert-success ">{{message}}</div>
            <div class="table-responsive">
                <table class="table mt-3 contenedorLista">
                    <thead>
                        <tr>
                            <th>Id</th>
                            <th>Nombre</th>
                            <th>Visible</th>
                            <th>Localidades</th>
                            <th>Hacer visible</th>
                            <th>Borrar</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor = "let etapa of etapas" class="filasEventos">
                            <td>{{etapa?.id}}</td>
                            <td>{{etapa?.nombre }}</td>
                            <td>{{etapa?.visible| booleans}}</td>
                            <td class="max-width"><button class="btn btn-success" routerLink="localidades/{{etapa.id}}">Localidades</button></td>
                            <td class="max-width"><button  class="btn btn-warning" (click)="hacerVisible(etapa.id)"> Hacer Visible</button></td>
                            <td class="max-width"><button  class="btn btn-danger" (click)="borrarEtapa(etapa.id)"> Delete</button></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="row wcien">
                <div class="col-12 mt-5" style="text-align: center;">
                    <button  routerLink="agregar" class="btn btn-success">Agregar Etapa</button>
                </div>
            </div>
        </div>
    </div>
</section>